import React from "react";
import { BigNumber } from "ethers";

export type VestingContextValue = {
  vestingAmountInBearsRemaining?: BigNumber[];
  vestingAmountInBearsRemainingSum?: BigNumber;
  readVestingAmountRemainingInBears: () => void;
  vestingAmountInJarsRemaining?: BigNumber[];
  vestingAmountInJarsRemainingSum?: BigNumber;
  readVestingAmountRemainingInJars: () => void;
  vestingAmountRemaining?: BigNumber;
};

const VestingContext = React.createContext<VestingContextValue>({
  readVestingAmountRemainingInBears: () => {},
  readVestingAmountRemainingInJars: () => {},
});

export default VestingContext;
